import { render, staticRenderFns } from "./SubjectAreasEdit.vue?vue&type=template&id=06507311&"
import script from "./SubjectAreasEdit.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreasEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports